import { Stack } from "@fluentui/react";
import React, { CSSProperties } from "react";
import { ShimmerLine } from "../../Shimmer/ShimmerLine/ShimmerLine";

const lineHeight = 12;

export type ToggleShimmerWidth = "72px" | "40px";

export interface ToggleShimmerProps {
    readonly width?: ToggleShimmerWidth;
}

const toggleShimmerHeightStyle: CSSProperties = {
    height: 57
};

export const ToggleShimmer: React.FC<ToggleShimmerProps> = ({
    width = "40px",
}) => (
        <Stack style={toggleShimmerHeightStyle} verticalAlign={"center"}>
            <ShimmerLine width={width} height={lineHeight} />
        </Stack>
    );
